(function () {
  try { console.log('%c YAPCITY RANDOM v9 loaded ', 'background:#2ed573;color:#000;padding:2px 6px;border-radius:3px'); } catch (e) {}

  var COLORS = ['#00b4d8', '#ff2e2e', '#8338ec', '#ff9f1c', '#2ed573', '#3a86ff', '#ff3cac'];
  function rand() { return COLORS[Math.floor(Math.random() * COLORS.length)]; }

  var HOVER_SEL = [
    '.product-link', '.btn', '.navigation__link', '.show-search-link',
    '.header-account-link', '.cart-link', '.social__link', '.announcement-bar__link',
    '.custom-select__btn', '.custom-select__option', '.disclosure__title',
    '.section-footer a:not(.btn)', '.link-dropdown__button', '.link-dropdown__link',
    '.filter-toggle', '.size-chart-link', '.cart-policies a', '#CartDrawerNoteToggle',
    '.opt-label--btn'
  ].join(',');

  var SIZE = '.opt-label--btn';
  var current = null;

  // Fresh random hover color each time you enter a new element.
  document.addEventListener('mouseover', function (e) {
    if (!e.target || !e.target.closest) return;
    var el = e.target.closest(HOVER_SEL);
    if (el === current) return;
    current = el;
    if (el) el.style.setProperty('--rnd-hover', rand());
  });

  // The exact color a size button is showing right now (its hover color).
  function shownColor(label) {
    var v = label.style.getPropertyValue('--rnd-hover');
    if (v && v.trim()) return v.trim();
    var cs = getComputedStyle(label);
    return cs.borderTopColor || rand();
  }

  // Capture the shown color at the moment of press — before the click resolves.
  var pending = null;
  function capture(t) {
    if (!t || !t.closest) return;
    var label = t.closest(SIZE);
    if (label) pending = shownColor(label);
  }
  document.addEventListener('pointerdown', function (e) { capture(e.target); }, true);
  document.addEventListener('mousedown',   function (e) { capture(e.target); }, true);
  document.addEventListener('touchstart',  function (e) { capture((e.touches && e.touches[0] && e.touches[0].target) || e.target); }, true);

  // Paint the currently-checked size with a locked color; clear the rest.
  function paintChecked() {
    document.querySelectorAll('.opt-btn').forEach(function (input) {
      var label = input.nextElementSibling;
      if (!label || !label.classList || !label.classList.contains('opt-label--btn')) return;

      if (input.checked) {
        // Selected size = constant solid black (hover stays random via CSS)
        label.style.setProperty('background-color', '#000000', 'important');
        label.style.setProperty('background', '#000000', 'important');
        label.style.setProperty('border-color', '#000000', 'important');
        label.style.setProperty('box-shadow', 'none', 'important');
        label.style.setProperty('color', '#ffffff', 'important');
        label.style.setProperty('transition', 'none', 'important');
      } else {
        // hand styling back to the CSS hover rules
        label.style.removeProperty('background-color');
        label.style.removeProperty('background');
        label.style.removeProperty('border-color');
        label.style.removeProperty('box-shadow');
        label.style.removeProperty('color');
      }
    });
    pending = null;
  }

  // Repaint whenever selection could have changed.
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest(SIZE)) {
      paintChecked();
      setTimeout(paintChecked, 0);
      setTimeout(paintChecked, 60);
    }
  });
  document.addEventListener('change', function (e) {
    if (e.target && e.target.classList && e.target.classList.contains('opt-btn')) paintChecked();
  });

  // Re-run when the theme injects option markup.
  var mo = new MutationObserver(function () { paintChecked(); });

  function start() {
    paintChecked();
    if (document.body) mo.observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
